module.exports = "<div class=\"inner cover\">\n\n</div>\n"